<!--
  공통 장비 필터

  @since 2018-09-28
  @author mk.ko
-->

<template>
  <layout-popup ref="deviceDialog"
                :titleName="titleName"
                :content-css="{width : '450px', height: (notVisible ? '679px' : '630px')}"
                :footerBtn= "footerBtn"
                :is-synced="isSynced"
                :synced.sync="syncedChecked"
                :syncEvt="onSync"
                :cancelEvt="onCancel"
                :confirmEvt="onConfirm"
                @hide="onHide"
                class="bs bs-q-modal bs-q-modal-flat"
  >
    <!-- 컨텐츠 시작 -->
    <div class="content-group">
      <div class="contents-row">
        <div class="portlet">

          <div v-if="notVisible" class="contents-row">
            <!-- 테이블 시작 -->
            <table class="bs-table table-bordered-none">
              <colgroup>
                <col width="30%"/>
                <col width="auto"/>
              </colgroup>
              <tbody>
                <tr>
                  <td class="td-head">NOT</td>
                  <td>
                    <div class="inline-group">
                      <q-toggle v-model="notChecked" class="bs bs-q-toggle bs-q-toggle-default" />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- 테이블 끝 -->
          </div>

          <hr v-if="notVisible" class="portlet-bottom-hr">

          <div class="contents-row">
  <!--          v-if="isShow"-->
            <device-tree ref="deviceTree"
                         default-expand-all
                         :isReadOnly="isReadOnly"
                         :height="`420px`"
                         :auto-render="false"
                         :enable-check-box="multiple"
                         :selected-multiple="selectedMultiple"

                         :only-group-yn="onlyGroupYn"
                         :only-config-yn="onlyConfigYn"
                         :tams-yn="tamsYn"
                         :slave-yn="slaveYn"
                         :except-mon-node-yn="exceptMonNodeYn"
                         :only-policy-mng-yn="onlyPolicyMngYn"
                         :only-tams-yn="onlyTamsYn"
                         :only-unregistered-yn="onlyUnregisteredYn"
                         :disable-search-device-type="disableSearchDeviceType"
                         :only-sdwan-lic-yn="onlySdwanLicYn"
                         :bluemax-model-type="bluemaxModelType"

                         :tree-type="treeType"
                         :menu-id="menuId"
                         :menu-sub-id="menuSubId"
                         :target-id="targetId"
                         :device-sub-type="deviceSubType"
                         @check="treeChecked"
            >

            </device-tree>
          </div>

        </div>
      </div>
    </div>
    <!-- 컨텐츠 끝 -->

  </layout-popup>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'

  // components
  import LayoutModalPopUp from '~/components/popUp/LayoutModalPopUp'
  import DeviceTree from '~/components/pageComponents/common/deviceTree/DeviceTree'

  // utils
  import { isDeviceGroupType } from '~/utils/common'

  // stores
  const { mapState, mapMutations, mapActions } = createNamespacedHelpers('common/filter')

  export default {
    name: 'filterDeviceDialog',
    components: {
      'layout-popup': LayoutModalPopUp,
      DeviceTree
    },
    props: {
      isReadOnly: {
        type: Boolean,
        default: false
      },

      // 디바이스 필터 팝업 제목
      titleName: {
        type: String,
        default () {
          return this.$t('cmn.deviceFilter')
        }
      },
      // 단일/복수 선택 모드
      multiple: {
        type: Boolean,
        default: false
      },
      // 단일 선택 시 다중 선택 비활성화
      selectedMultiple: {
        type: Boolean,
        default: false
      },
      autoConfirmHide: {
        type: Boolean,
        default: true
      },

      // 기본값 설정 유무 (최소 한개의 아이템은 선택되어야함)
      requireSelected: {
        type: Boolean,
        default: false
      },
      notVisible: {
        type: Boolean,
        default: false
      },

      // device-tree REST API 옵션
      onlyGroupYn: {
        type: Boolean,
        default: false
      },
      onlyConfigYn: {
        type: Boolean,
        default: true
      },
      tamsYn: {
        type: Boolean,
        default: false
      },
      slaveYn: {
        type: Boolean,
        default: false
      },
      exceptMonNodeYn: {
        type: Boolean,
        default: false
      },
      onlyPolicyMngYn: {
        type: Boolean,
        default: false
      },
      onlyTamsYn: {
        type: Boolean,
        default: false
      },
      // 방화벽 미지정 장비 및 장비그룹만 로딩할지 여부 (NGF Only)
      onlyUnregisteredYn: {
        type: Boolean,
        default: false
      },
      disableSearchDeviceType: {
        type: Boolean,
        default: false
      },
      // BLUEMAX 관리 장비 필터링
      bluemaxModelType: {
        type: String,
        default: '',
        validator: (v) => {
          let validation = true
          _.forEach(v.split(','), val => {
            if (!['ngf', 'ips', 'ads', 'wips', 'mf2', 'mfi', 'mfd', ''].includes(val.trim())) {
              validation = false
              return false
            }
          })
          return validation
        }
      },
      footerBtn: {
        type: Array,
        default () {
          return ['cancel', 'confirm']
        }
      },

      // 대시보드 장비 트리 (특정 메뉴 내 전역 장비 적용 여부 기능)
      isSynced: {
        type: Boolean,
        default: false
      },
      synced: {
        type: Boolean,
        default: true
      },
      syncedData: {
        type: Array,
        default () {
          return []
        }
      },

      // 메뉴 트리 (특정 메뉴 내 조회 옵션 의존 기능)
      treeType: {
        type: Number,
        default: 0
      },
      menuId: {
        type: Number,
        default: 0
      },
      menuSubId: { // 메뉴내에 Tab 구분시 Sub Id만 받아서 처리 가능하도록 추가함.
        type: Number,
        default: void 0
      },
      targetId: {
        type: Number,
        default: 0
      },
      // 하위 TAMS 타입 (true: 상/하위, false: 상위)
      deviceSubType: {
        type: Boolean,
        default: () => true
      },
      // SD-WAN 라이선스 전용 장비 표시 여부 (기본값 : false)
      onlySdwanLicYn: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        // 실제 선택된 커밋될 아이템 키 (multiple, single 둘 모두)
        selectedItem: void 0,
        // 모달 창 팝업 시, 비정상 랜더링 방지
        isShow: false,
        // NOT Toggle
        notChecked: false,
        // 전역 필터 동기화
        syncedChecked: false
      }
    },
    created () {
      this.initStore()
    },
    beforeDestroy () {
      this.initStore()
    },
    computed: {
      ...mapState([
        'devicesTreeData'
      ])
    },
    mounted () {},
    methods: {
      ...mapMutations([
        'initStore'
      ]),
      ...mapActions([
        'getDevicesTreeData'
      ]),

      initData () {
        this.selectedItem = void 0
        this.isShow = false
        this.notChecked = false
        // this.syncedChecked = false
      },
      /**
       * 장비 트리 다이얼로그 열기
       * ---
       * @param selectedItem {Array|Number} : 초기값 세팅시 노드를 지정하고자 하는 경우 (default: undefined)
       */
      async show ({ selectedItem, notChecked } = {}) {
        try {
          this.isShow = true
          this.notChecked = (typeof notChecked === 'undefined') ? false : notChecked
          // isSynced 가 True 일 경우에만 synced 사용.
          this.syncedChecked = this.isSynced && this.synced
          this.filter = ''
          await this.$refs.deviceDialog.show()

          // 전역 필터 동기화시 동기화 Data 우선 적용.
          const items = (this.syncedChecked ? this.syncedData : selectedItem || this.selectedItem || [])
          this.loadTreeData(items)
        } catch (e) {
          this.$log('[Filter Device Dialog GUI Error (show)]', e)
        }
      },

      /**
       * 장비 트리 다이럴로그 닫기기
       * ---
       */
      hide () {
        this.$refs.deviceDialog.hide()
        this.isShow = false
      },
      onHide () {
        this.initData()
      },
      onCancel () {
        this.$emit('cancel')
      },
      /**
       * 장비 트리 다이얼로그 필터 적용
       * ---
       */
      onConfirm () {
        try {
          const selectedItems = this.$refs.deviceTree.getSelectedNodes()

          if (this.requireSelected && _.get(selectedItems, ['length'], 0) === 0) {
            this.$alertPopUp.show(this.$t('cmn.msg_atLeastOneItem'))
            return
          }

          if (_.get(selectedItems, ['length'], 0) > 0) {
            this.selectedItem = selectedItems
          } else {
            this.selectedItem = void 0
          }

          this.$emit('confirm', {
            selectedItem: this.selectedItem,
            notChecked: this.notChecked
          })

          if (this.autoConfirmHide) {
            this.hide()
          }
        } catch (e) {
          this.$log('[Filter Device Dialog GUI Error (onConfirm)]', e)
        }
      },

      async loadTreeData (selectedItem, isLoading = true, reload = false) {
        try {
          if (typeof this.$refs.deviceTree !== 'undefined') {
            await this.$refs.deviceTree.loadTreeData(selectedItem, isLoading, reload)
          }
        } catch (e) {
          this.$log('[Filter Device Dialog GUI Error (loadTreeData)]', e)
        }
      },

      /**
       * 선택된 장비 트리 필터 아이템 반환
       * ---
       * @returns {Array|Number} : 장비키 값
       */
      getSelectedItem () {
        try {
          if (
            this.requireSelected &&
            _.get(this.selectedItem, ['length'], 0) === 0
          ) {
            const allDeviceItems = _.filter(this.devicesTreeData, node => {
              return !isDeviceGroupType(node.device_type) || this.onlyGroupYn
            })
            if (this.multiple) {
              this.selectedItem = allDeviceItems
            } else {
              this.selectedItem = allDeviceItems[0]
            }
          }
          return this.selectedItem
        } catch (e) {
          this.$log('[Filter Device Dialog GUI Error (getSelectedItem)]', e)
        }
      },

      async getData () {
        try {
          if (_.get(this.devicesTreeData, ['length'], 0) === 0) {
            await this.loadTreeData(void 0, true, true)
          }

          return this.devicesTreeData
        } catch (e) {
          this.$log('[Filter Device Dialog GUI Error (getData)]', e)
        }
      },

      async makeSelectedItemName ({ selectedItem, innerText = false } = {}) {
        try {
          if (_.get(this.devicesTreeData, ['length'], 0) === 0) {
            await this.loadTreeData(void 0, true, true)
          }

          return this.getSelectedDevices({
            selectedItem,
            innerText
          })
        } catch (e) {
          this.$log('[Filter Device Dialog GUI Error (makeSelectedItemName)]', e)
        }
      },
      /**
       * 장비 필터 텍스트 반환
       * ---
       * @param selectedItem {Array|Number} : 선택한 장비 키 값
       * @param innerText {Boolean} : 필터 내부 temp 장비 필터 텍스트 인 경우 (default: false)
       * @returns {String} : 장비 필터 Text
       */
      async makeSelectedItemLabel (selectedItem, innerText = false, separator = '{{sep_comma}}') {
        try {
          if (_.get(this.devicesTreeData, ['length'], 0) === 0) {
            await this.loadTreeData(void 0, true, true)
          }

          return this.getSelectedDevices({
            selectedItem,
            innerText,
            separator,
            join: true
          })
        } catch (e) {
          this.$log('[Filter Device Dialog GUI Error (makeSelectedItemLabel)]', e)
        }
      },

      getSelectedDevices ({ selectedItem, innerText, join = false, separator = ',', returnFullItems = false } = {}) {
        let res = []

        try {
          let deviceNames = [], selectedDatas = []
          if (_.get(selectedItem, ['length'], 0) > 0) {
            _.each(this.devicesTreeData, row => {
              if (selectedItem.some(key => row.device_id === key.device_id || row.device_id === key)) {
                deviceNames.push(row.device_uname)
                selectedDatas.push(row)
              }
            })
          }

          if (returnFullItems) {
            res = selectedDatas
          } else {
            if (join) {
              if (_.get(deviceNames, ['length'], 0) === 1) {
                res = deviceNames[0]
              } else {
                res = deviceNames.join(separator)
              }
            } else {
              res = deviceNames
            }
          }
        } catch (e) {
          this.$log('[Filter Device Dialog (getSelectedDevices)]', e)
        }
        return res
      },

      treeChecked ({checkedItem}) {
        if (this.isSynced) {
          this.$refs.deviceDialog.syncedChecked = false
        }
      },
      async onSync () {
        if (this.isSynced) {
          await this.loadTreeData(this.syncedData, false)
        }
      }
    },
    watch: {
      syncedChecked (value) {
        if (value) {
          this.onSync()
        }

        this.$emit('update:synced', value)
      }
    }
  }
</script>

<style scoped>
</style>
